import styled from 'styled-components'
import colors from '../../theme/colors'
import fonts from '../../theme/fonts'

export type HeadingProps = {
  size?: 'xsmall' | 'small' | 'medium' | 'large' | 'xlarge'
}

const Heading = styled.h1<HeadingProps>`
  margin: 0;
  font-family: ${fonts.fontFamilies.Montserrat};
  font-style: normal;
  letter-spacing: 0.02em;
  text-align: left;
  color: ${colors.Primary.GreyText};

  ${({ size = 'xsmall' }) => {
    if (size === 'xsmall') {
      return `
        font-size: ${fonts.fontSizes.p18};
        line-height: 24px;
        font-weight: ${fonts.fontWeights.large};
      `
    } else if (size === 'small') {
      return `
        font-size: ${fonts.fontSizes.p22};
        line-height: 28px;
        font-weight: 600;
      `
    } else if (size === 'medium') {
      return `
        font-size: ${fonts.fontSizes.p24};
        line-height: 32px;
        font-weight: 600;
      `
    } else if (size === 'large') {
      return `
        font-size: ${fonts.fontSizes.p32};
        line-height: 40px;
        font-weight: ${fonts.fontWeights.large};
      `
    } else if (size === 'xlarge') {
      return `
        font-size: ${fonts.fontSizes.p40};
        line-height: 48px;
        font-weight: ${fonts.fontWeights.large};
      `
    }
  }}
`

export default Heading
